import { render } from "./TextLink.vue?vue&type=template&id=154d4578"
import script from "./TextLink.vue?vue&type=script&lang=js"
export * from "./TextLink.vue?vue&type=script&lang=js"
script.render = render

export default script